import { render, staticRenderFns } from "./ReportsAux.vue?vue&type=template&id=6ac6ce96&"
import script from "./ReportsAux.vue?vue&type=script&lang=js&"
export * from "./ReportsAux.vue?vue&type=script&lang=js&"
import style0 from "./ReportsAux.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports